import { Link } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';

/** Reprise de l'écran `acces-refuse` de la maquette validée. */
export function AccesRefusePage(): JSX.Element {
  const { utilisateur } = useAuth();

  return (
    <div className="mx-auto max-w-3xl p-4 sm:p-6">
      <div className="rounded-2xl border border-gray-100 bg-white p-10 text-center shadow-card">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-red-50">
          <svg aria-hidden="true" className="h-6 w-6 text-red-500" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
            />
          </svg>
        </div>

        <h1 className="font-display text-lg font-bold text-codialis-navy">
          Cette rubrique n’est pas disponible
        </h1>
        <p className="mx-auto mt-2 max-w-lg text-sm text-codialis-gray">
          Elle ne fait pas partie de votre espace de travail
          {utilisateur ? ` (${utilisateur.libelleProfil})` : ''}. Si vous pensez qu’il s’agit
          d’une erreur, contactez la direction.
        </p>

        <Link
          to="/dashboard"
          className="mt-6 inline-flex rounded-xl bg-codialis-navy px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-codialis-deep"
        >
          Retour au tableau de bord
        </Link>
      </div>
    </div>
  );
}
